<svg viewBox="0 0 32 32" width="32" height="32">
    <circle cx="16" cy="16" r="16" [attr.fill]="combatant.glob_color"/>
</svg>
